<template>
    <!-- Transparent backdrop: any press outside the list closes the picker. -->
    <div class="fixed inset-0 z-50" @mousedown.self="$emit('close')" @keydown.esc="$emit('close')">
        <div ref="panel" tabindex="-1"
            class="absolute max-h-80 w-56 overflow-y-auto rounded border border-white/30 bg-slate-800 p-1.5 text-xs text-white shadow-lg focus:outline-none"
            :style="{ left: `${left}px`, top: `${top}px` }">
            <div class="mb-1 px-0.5 text-[10px] uppercase tracking-wide text-gray-300">Add and connect</div>
            <div v-for="group in groups" :key="group.id" class="mb-1">
                <div class="px-0.5 text-[10px] text-gray-400">{{ group.label }}</div>
                <button v-for="entry in group.entries" :key="entry.id" type="button"
                    class="block w-full truncate rounded px-1 py-0.5 text-left hover:bg-white/10"
                    @click="$emit('pick', entry)">
                    <span class="inline-block w-4 text-center" :style="{ color: entry.color }">{{ entry.icon }}</span>
                    {{ entry.label }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref } from 'vue';

/** Node choices for a wire released on empty canvas (see LogicLayer onWireToEmpty). */
const props = defineProps({
    x: { type: Number, required: true },
    y: { type: Number, required: true },
    groups: { type: Array, required: true },
});
defineEmits(['pick', 'close']);
const panel = ref(null);

// Keep the list on screen near the pointer.
const left = computed(() => Math.max(4, Math.min(props.x, window.innerWidth - 232)));
const top = computed(() => Math.max(4, Math.min(props.y, window.innerHeight - 330)));

onMounted(() => nextTick(() => panel.value?.focus()));
</script>
